<div class="thumbnail-container thumbnail-background"
     [style.cursor]="isClickable ? 'pointer' : 'default'"
     [style.width]="width"
     [style.height]="height"
     (click)="isClickable ? clicked() : null"
>
  <ng-container *ngIf="asset; else addMedia">
    <button *ngIf="isEditButtonDisplayed" class="thumbnail-edit-button" mat-icon-button>
      <mat-icon>create</mat-icon>
    </button>
    <div  [matTooltip]="getDeleteButtonTooltips()">
      <button *ngIf="isDeleteButtonDisplayed" class="thumbnail-delete-button" mat-icon-button
              (click)="deleted($event)"
              [disabled]="isDeleteButtonDisabled"
      >
        <mat-icon>delete</mat-icon>
      </button>
    </div>
    <div
      [style.width]="isCircular ? height: width"
      [style.height]="height"
      [class]="isCircular ? 'is-circular-cropper' : ''"
      [style.max-width]="'100%'"
    >
      <img *ngIf="asset.thumbnail; else noThumb" [src]="asset.thumbnail" [style.border-radius]="isCircular ? '50%' : '0'" [style.object-fit]="forceContain ? 'contain' : 'cover'">
    </div>
    <ng-template #noThumb>
      <mat-icon class="centered-icon thumbnail-background">{{ placeholderIcon }}</mat-icon>
    </ng-template>
  </ng-container>
  <ng-template #addMedia>
    <div class="media-placeholder">
      <mat-icon class="centered-icon interactive-icon">add_circle</mat-icon>
    </div>
  </ng-template>
</div>
<div  *ngIf="asset && asset.name && isNameDisplayed;" class="asset-name mat-caption">
  <span>{{asset.name}}</span>
</div>
<div  *ngIf="!asset && mediaMissingDisplayedMessage;" class="asset-name mat-caption">
  <span>{{mediaMissingDisplayedMessage}}</span>
</div>
<div *ngIf="!asset && isMediaErrorDisplayed" class="mat-error">
  Media not found. Please select another one.
</div>
